import {primaryPaneOptionCollection} from "../../../primary_pane_option_collection";

export function getLastPaneOptionFromOpenedMapFilterCodes(sm) {
    let mapFilterCodes = getMapFilterCodesFromOpenedMapFilterCodes(sm);
    // Collect up the pane option components that match the map filter codes and remove nulls.
    const paneOptions = mapFilterCodes.map(code => primaryPaneOptionCollection.withIdentifier(code)).filter(paneOption => !!paneOption);
    return paneOptions[paneOptions.length - 1];
}

function getMapFilterCodesFromOpenedMapFilterCodes(sm) {
    const mapFilterCodes = sm.state['openedMapFilterCodes'];

    // When the app is first loaded, the openedMapFilterCodes will be empty.
    // In this case, we should use the default map filter code.
    if (mapFilterCodes.length === 0) {
        const nav = sm.getStateableObject(); // Get a reference to the stateable object which should be our Nav instance.
        if (nav) mapFilterCodes.push(nav.getInitialMapFilterCode());
    }

    return mapFilterCodes;
}
